import React, { Component } from "react";
import { Stage } from "react-konva";
import ExternalLayer from "./Layers/External.Layer";
import { TASK_TYPE } from "../store/constants";
import DrawingLayer from "./Layers/Drawing.Layer";
import { connect } from "react-redux";
import {
  //syncWithServer,
  chooseModeType,
  changePageNumber,
  performUndo,
  initWhiteBoard,
  clearAll
} from "../store/actions/mode.action";
import {
  updateMousePosition,
  updateMouseDown
} from "../store/actions/mouse.action";
//import { initConfig } from "../store/actions/config.action";
import BackGroundLayer from "./Layers/BackGround.Layer";
import { changePencilModeColor } from "../store/actions/modes/pencil.mode.action";

class WhiteBoard extends Component {
  constructor(props) {
    super(props);
    this.runTask = this.runTask.bind(this);
  }

  componentDidMount() {
    const { config, setClick } = this.props;
    //this.props.dispatch(initConfig(config));
    //this.props.dispatch(syncWithServer(config));
    setClick(this.runTask);
  }

  componentDidUpdate() {
    // TODO
    //console.log("rendering whiteboard");
  }

  handleMouseMove = e => {
    const { offsetX, offsetY } = e.evt;
    this.props.dispatch(updateMousePosition(offsetX, offsetY));
  };

  handleMouseDown = () => {
    this.props.dispatch(updateMouseDown(true));
  };

  handleMouseUp = () => {
    this.props.dispatch(updateMouseDown(false));
  };

  runTask(type, data) {
    switch (type) {
      case TASK_TYPE.INIT_WHITEBOARD:
        const { flowId, hostName, theme } = data;
        this.props.dispatch(initWhiteBoard(flowId, hostName, theme));
        break;
      case TASK_TYPE.CHOOSE_MODE_TYPE:
        const { modeType } = data;
        this.props.dispatch(chooseModeType(modeType));
        break;

      case TASK_TYPE.CHANGE_PENCIL_MODE_COLOR:
        const { color } = data;
        this.props.dispatch(changePencilModeColor(color));
        break;

      case TASK_TYPE.CHANGE_PAGE_NUMBER:
        const { pageNumber } = data;
        this.props.dispatch(changePageNumber(pageNumber));
        break;

      case TASK_TYPE.PERFORM_UNDO:
        this.props.dispatch(performUndo());
        break;

      case TASK_TYPE.CLEAR_ALL:
        this.props.dispatch(clearAll());
        break;

      default:
        console.log("running unknown task with data ..." + data);
        return;
    }
  }

  render() {
    return (
      // <Provider store={store}>
      <Stage
        width={window.innerWidth}
        height={window.innerHeight}
        onMouseMove={this.handleMouseMove}
        onMouseDown={this.handleMouseDown}
        onMouseUp={this.handleMouseUp}
      >
        <ExternalLayer>{this.props.children}</ExternalLayer>
        <BackGroundLayer theme={this.props.theme + ".svg"}></BackGroundLayer>
        <DrawingLayer store={this.props.store}></DrawingLayer>
      </Stage>
    );
  }
}

WhiteBoard.defaultProps = {
  config: {
    theme: "themeNone"
  }
};

const mapStateToProps = state => {
  const { theme } = state.modeReducer;
  return { theme };
};

export default connect(mapStateToProps)(WhiteBoard);
